export default "__VITE_ASSET__DPzQfDga__"